/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_X15_Wrong_GoogleInputs */



/**
* | output |
* | --- |
* | "That Google account uses a different address. Sign in with the invited address, or ask for an invitation to this one." |
*
* @param {Auth_X15_Wrong_GoogleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_x15_wrong_google = /** @type {((inputs?: Auth_X15_Wrong_GoogleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_X15_Wrong_GoogleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("That Google account uses a different address. Sign in with the invited address, or ask for an invitation to this one.")
});